@if (client()) {
  <mat-card-subtitle class="my-4">Device Licensing</mat-card-subtitle>

  <div class="flex flex-row items-center mb-5 text-sm">
    <span class="input-main-label">Monitored Devices</span>
    <span [style.color]="isOverLimit() ? 'var(--ui-error)' : undefined">
      {{ client()!.monitoredDeviceCount ?? '—' }}
    </span>
  </div>

  <div class="flex flex-row items-center mb-5 text-sm">
    <label
      class="input-main-label"
      for="licensed-device-count"
    >Licensed Devices</label>
    @if (isReadOnly()) {
      <span>{{ licensedCount() || 0 }}</span>
    } @else {
      <mat-form-field
        class="input-classic input-main no-error-message"
        appearance="outline"
      >
        <input
          id="licensed-device-count"
          type="number"
          (blur)="onBlur()"
          (input)="onInput($event)"
          [value]="licensedCount()"
          matInput
          min="0"
        />
      </mat-form-field>
    }
  </div>
}
